import { useController, useFormContext } from 'react-hook-form';
// eslint-disable-next-line import/no-named-as-default-member
import { useEffect } from 'react';
import InputComponent from './component';

const Input = ({
  name,
  required = false,
  isClearable = false,
  defaultValue = '',
  ...restProps
}) => {
  const { control, setValue, setFocus } = useFormContext() || {};

  useEffect(
    () => {
      if(restProps.isFocusedOnMount) {
        setFocus(name);
      }
    },
    [restProps.isFocusedOnMount],
  );
  const {
    field: { ref, ...inputProps },
    fieldState: { error, isDirty },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
    shouldUnregister: false,
  });

  return (
    <InputComponent
      {...inputProps}
      {...restProps}
      error={error}
      required={required}
      name={name}
      isDirty={isDirty}
      inputRef={ref}
      onClear={isClearable && inputProps.value ? () => {
        setValue(name, defaultValue, {
          shouldDirty: true,
        });
      } : undefined}
    />
  );
};

export default Input;
